import type { StateStorage } from "zustand/middleware";

const UNAVAILABLE_STORAGE: StateStorage = {
  getItem: () => null,
  setItem: () => undefined,
  removeItem: () => undefined,
};

/** Web Storage拒否時もメモリ上のstore操作を継続できるpersist用storageを返す */
export function resolveSafePersistStorage(
  storage?: StateStorage,
): StateStorage {
  if (storage) return makeStorageSafe(storage);

  try {
    const localStorage = globalThis.localStorage;
    return localStorage ? makeStorageSafe(localStorage) : UNAVAILABLE_STORAGE;
  } catch {
    return UNAVAILABLE_STORAGE;
  }
}

function makeStorageSafe(storage: StateStorage): StateStorage {
  return {
    getItem(name: string): string | null | Promise<string | null> {
      try {
        const value = storage.getItem(name);
        return value instanceof Promise ? value.catch((): null => null) : value;
      } catch {
        return null;
      }
    },
    setItem(name: string, value: string): unknown {
      try {
        const result = storage.setItem(name, value);
        return result instanceof Promise
          ? result.catch((): void => undefined)
          : result;
      } catch {
        // Storage拒否やquota超過でもメモリ上の状態更新は維持する
      }
    },
    removeItem(name: string): unknown {
      try {
        const result = storage.removeItem(name);
        return result instanceof Promise
          ? result.catch((): void => undefined)
          : result;
      } catch {
        // Storage拒否でもメモリ上の状態は維持する
      }
    },
  };
}
